/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Subscription_Rights_Friend_GuestInputs */

const fr_admin_subscription_rights_friend_guest = /** @type {(inputs: Admin_Subscription_Rights_Friend_GuestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invités (1 ami)`)
};

/**

* @param {Admin_Subscription_Rights_Friend_GuestInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const admin_subscription_rights_friend_guest = /** @type {((inputs?: Admin_Subscription_Rights_Friend_GuestInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Subscription_Rights_Friend_GuestInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_admin_subscription_rights_friend_guest(inputs)
});